import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Constants } from 'src/app/providers/Constants';
// import { isSameDay } from 'ngx-bootstrap/chronos';
import { TimeProvider, TimeEvent } from '../time.provider';
import { Router } from '@angular/router';


@Component({
    selector: 'month-calendar',
    templateUrl: './month.calendar.html',
    styleUrls: ['./month.calendar.scss'],
})
export class MonthCalendar implements OnInit, OnChanges {

    @Input('viewDate')
    viewDate: Date;

    @Input('data')
    data: TimeEvent[] = [];

    @Input("filter")
    filter: any;

    @Input('hideNavigation')
    hideNavigation: boolean = null;

    @Output('dateSelected')
    onDateSelected: EventEmitter<Date> = new EventEmitter<Date>();
    
    cells: DayCell[][] = [];

    today: Date;
    month: Month;

    public static monthNames: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    public static dayNames: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    monthNames: string[] = MonthCalendar.monthNames;
    dayNames: string[] = MonthCalendar.dayNames;
    
    constructor(private provider: TimeProvider, private router: Router) {
    }

    ngOnInit() {
        this.today = new Date();

        if (this.viewDate) {
            this.month = new Month();
            this.month.year = this.viewDate.getFullYear();
            this.month.rank = this.viewDate.getMonth();
            this.month.name = MonthCalendar.monthNames[this.month.rank];
        } else {
            this.month = new Month();
            this.month.year = this.today.getFullYear();
            this.month.rank = this.today.getMonth();
            this.month.name = MonthCalendar.monthNames[this.month.rank];
        }

        this.render();

        if (this.data && this.data.length) {
            this.fillCells(this.data);
        } else {
            this.fetch();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.today = new Date();

        let priorYear = (this.month)? this.month.year : -1;
        let priorMonth = (this.month)? this.month.rank : -1;

        if (changes.viewDate) {
            this.month = new Month();
            this.month.year = this.viewDate.getFullYear();
            this.month.rank = this.viewDate.getMonth();
            this.month.name = MonthCalendar.monthNames[this.month.rank];
        } else {
            this.month = new Month();
            this.month.year = this.today.getFullYear();
            this.month.rank = this.today.getMonth();
            this.month.name = MonthCalendar.monthNames[this.month.rank];
        }

        if (changes.data || changes.filter || this.month.rank != priorMonth || this.month.year != priorYear) {
            this.render();
        }

        if (changes.data) {     //} && this.data.length) {
            this.fillCells(this.data);
        } else if (changes.filter || this.month.rank != priorMonth || this.month.year != priorYear) {
            this.fetch();
        }
    }

    fillCells(data: TimeEvent[]) {
        for(let row of this.cells) {
            for(let cell of row) {
                cell.marks = [];
                cell.times = [];

                for(let event of data) {
                    if (event.starts) event.starts = new Date(event.starts);
                    if (event.ends) event.ends = new Date(event.ends);

                    cell.read(event);
                }
            }
        }
    }

    fetch() {

        this.provider.getEvents(this.filter)
        .then(data => {
            if (data) {
                this.fillCells(data);
            }
        })

        // let url = "https://192.168.0.234:3000/event/fetch?root=1";

        // this.http.get(url, Constants.httpOptions)
        // .toPromise()
        // .then(data => {
        //     console.log(data);

        //     if (Array.isArray(data)) {
        //         for(let row of this.cells) {
        //             for(let cell of row) {
        //                 cell.marks = [];
        //                 cell.times = [];

        //                 for(let event of data) {
        //                     if (event.starts) event.starts = new Date(event.starts);
        //                     if (event.ends) event.ends = new Date(event.ends);

        //                     cell.read(event);
        //                 }
        //             }
        //         }
        //     }
        // })
    }

    render() {
        let firstDayOfMonth: Date = new Date();
        firstDayOfMonth.setDate(1);
        firstDayOfMonth.setMonth(this.month.rank);
        firstDayOfMonth.setFullYear(this.month.year);

        // let nextMonth: number = firstDayOfMonth.getMonth() + 1;
        
        let firstCol = firstDayOfMonth.getDay();
        let rollingDate: Date = null;
        this.cells = [];

        for(let r of [0,1,2,3,4]) {
            let rowCells: DayCell[] = [];
            this.cells.push(rowCells);

            for(let c of [0,1,2,3,4,5,6]) {
                let dayCell = new DayCell();
                dayCell.row = r;
                dayCell.col = c;
                
                if (rollingDate) {
                    rollingDate.setDate(rollingDate.getDate() + 1);
                    if (rollingDate.getMonth() != this.month.rank) {
                        rollingDate = null;
                    }
                } else {
                    if (c == firstCol && r == 0) {
                        rollingDate = firstDayOfMonth;
                    }
                }

                dayCell.date = rollingDate? new Date(rollingDate) : null;

                rowCells.push(dayCell);
            }
        }
    }

    selectDate(date: Date) {
        if (this.data && this.data.length) {
            let dstr = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
       
            this.router.navigateByUrl('/timeline?from=' + dstr + '&to=' + dstr);
        } else {
            if (this.onDateSelected) {
                this.onDateSelected.emit(date);
            }
        }
    }

    backMonth() {
        let year = this.month.year;
        let month = this.month.rank - 1;
        if (month < 0) {
            year = year - 1;
            month = 11;
        }
        this.month.year = year;
        this.month.rank = month;
        this.month.name = MonthCalendar.monthNames[this.month.rank];
        this.month.events = [];

        this.fetch();
        this.render();
    }

    nextMonth() {
        let year = this.month.year;
        let month = this.month.rank + 1;
        if (month > 11) {
            year = year + 1;
            month = 0;
        }
        this.month.year = year;
        this.month.rank = month;
        this.month.name = MonthCalendar.monthNames[this.month.rank];
        this.month.events = [];

        this.fetch();
        this.render();
    }

    /*getDayCell(event: any): DayCell {
        let moDay = date.getDate();

        for(let row of this.cells) {
            for(let cell of row) {
                if (cell.date.getDate() == moDay) {
                    return cell;
                }
            }
        }
        return null;
    }*/

    public static isSame(date: Date, other: Date): boolean {
        if (!date || !other) return false;

        try {
            return date &&
               (date.getFullYear() === other.getFullYear()) &&
               (date.getMonth() === other.getMonth()) &&
               (date.getDate() === other.getDate());
        } catch {
            console.error('Exception', date, other);
        }
    }

    isToday(date: Date): boolean {
            return MonthCalendar.isSame(date, this.today);
    }
}

export class Month {
    name: string;
    rank: number;
    year: number;
    events: any[] = [];
}

export class DayCell {
    date: Date;
    row: number;
    col: number;
    marks: any[] = [];
    times: any[] = [];

    public read(event: any) {
        if (!this.date) return;
        if (!event || !event.starts) return;

        if (event.ends) {
            let st = new Date(this.date);
            st.setHours(0); st.setMinutes(0); st.setSeconds(0);
            let left = Math.max(st.getTime(), event.starts.getTime());

            let et = new Date(this.date);
            et.setHours(23); et.setMinutes(59); et.setSeconds(59);
            let right: number;
            if (event.allday) {
                let lt = new Date(event.ends);
                lt.setHours(23); lt.setMinutes(59); lt.setSeconds(59);
                right = Math.min(et.getTime(), lt.getTime())
            } else {
                right = Math.min(et.getTime(), event.ends.getTime())
            }

            if (right >= left) {
                this.add(event);
            }
            // if (st.getTime() >= event.starts.getTime()) {

            //     let et = new Date(this.date);
            //     et.setHours(23); st.setMinutes(59); st.setSeconds(59);
            //     if (et.getTime() <= event.ends.getTime()) {
            //         this.add(event);
            //     }
            // }

        } else {
            // console.log('Checking ', this.date, event.starts);
            if (MonthCalendar.isSame(this.date, event.starts)) {
                this.add(event)
            }
        }
    }

    add(event: any) {
        if (event.allday) {
            this.marks.push(event)
        } else {
            this.times.push(event)
        }
        // console.log('DayCell is now ', this);
    }
}